module.exports = __webpack_public_path__ + "img/menu-pontos.ffda10ab.svg";